import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { useAuthProvider, useGetList, useNotify, useTranslate, useUpdate } from 'ra-core';
import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { dataProvider } from '../../lib/dataProvider';
import { Checkbox, Chip, FormControlLabel, FormGroup, FormLabel, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent } from '@mui/material';


export const OnboardingSelectDepartments = () => {
  const translate = useTranslate();
  const authProvider = useAuthProvider();
  const navigate = useNavigate();
  const [membership, setMembership] = useState<any>()
  const [data, setData] = useState([])
  const [departments, setDepartments] = useState<string[]>([]);
  const [update] = useUpdate()
  const notify = useNotify();
  
  useEffect(() => {
    const loadDepartments = async () => {
      const membershipData = await authProvider.getMembership();
      if(membershipData?.ltoId) 
      {
        setMembership(membershipData);
        const departmentsData = await dataProvider.getList('departments', { 
          filter: { ltos: membershipData?.ltoId },
          pagination: { page: 1, perPage: 999 },
          sort: { field:'name' , order: 'ASC' },
          meta: {
            ignoreUserDepartmentFilter: true
          } 
        });

        setData(departmentsData.data);
      }
    }

    loadDepartments();
  },[])

  const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if(membership && departments.length)
    {
      update('memberships', {
        id: membership.id,
        data: {
            ltoId: membership.ltoId,
            memberFrom: membership.fromDate,
            memberTo: membership.toDate,
            departmentIds: departments
          }
        },
        {
          onSuccess: async () => {
            await dataProvider.post('/my/profiles/onboarding-completed')
            navigate("/")
          }
        }
      );
    }
    else 
    {
      notify(translate(`lto.screens.onboarding_selectdepartments.minum_selection_error`), { type: 'error'})
    }
  }, [update, departments, membership]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { target: { checked, id } } = event;
    const newValues = [...(departments || [])]
    const index = newValues.indexOf(id);

    if (checked) {
      if (index === -1) newValues.push(id);
    } else {
      if (index === -1) return; // weird.

      newValues.splice(index, 1);
    }

    setDepartments(newValues);
  };
  
  return(
    <Container component="main" maxWidth="xs">
      <CssBaseline />

      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          {translate(`lto.screens.onboarding_selectdepartments.title`)}
        </Typography>
        <Typography component="div" variant="body1">
          {translate(`lto.screens.onboarding_selectdepartments.subtitle`)}
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 3 }}>
          <Typography component="b" variant='body1'>{translate(`lto.screens.onboarding_selectdepartments.departments`)}</Typography>
          <FormGroup style={{maxHeight: 400, overflow: 'auto', flexWrap: 'nowrap'}}>
            {data.map((department) => (
              <FormControlLabel
                control={
                  <Checkbox id={department.id} checked={departments.includes(department.id)} onChange={handleChange} name={department.name} />
                }
                label={department.name}
              />
            ))}
          </FormGroup>

          <Button type="submit" fullWidth variant="contained" sx={{ mt: 2, mb: 1 }}>
            {translate(`lto.screens.onboarding_selectdepartments.save`)}
          </Button>
        </Box>
      </Box>
    </Container>
  )
}